import React from "react";

export function Toast({ message, onClose }) {
  React.useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 3200);
    return () => clearTimeout(t);
  }, [message, onClose]);
  if (!message) return null;
  return (
    <div className="toast" data-testid="toast">
      <i className="fas fa-bolt text-[#14b8a6] mr-2" />
      {message}
    </div>
  );
}
